import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Torihiki = props => {
  return <Dropdown.Static kubunKey='torihiki' {...props} />
}
